/* GLITER landing: typewriter band, „add the set of three” button, hero video under reduced motion.
   The set button posts to Shopify's /cart/add like Dawn's product form and hands the response to the theme's cart
   (our sb-cart drawer or Dawn's drawer), so the drawer opens exactly as after „Dodaj do koszyka”. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('gl-typewriter')) {
    class GlTypewriter extends HTMLElement {
      connectedCallback() {
        this.out = this.querySelector('[data-gl-word]');
        this.words = (this.dataset.words || '')
          .split('|')
          .map((w) => w.trim())
          .filter(Boolean);
        if (!this.out || this.words.length < 2) return;
        this.i = 0;
        this.n = this.words[0].length;
        this.deleting = true;
        this.visible = false;
        this.io = new IntersectionObserver(
          ([entry]) => {
            this.visible = entry.isIntersecting;
            if (this.visible) this.later(1400);
          },
          { threshold: 0.25 }
        );
        this.io.observe(this);
        this.onVisibility = () => !document.hidden && this.visible && this.later(600);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.onReduce = () => reduce.matches && this.reset();
        reduce.addEventListener('change', this.onReduce);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        reduce.removeEventListener('change', this.onReduce);
      }

      reset() {
        clearTimeout(this.timer);
        this.timer = null;
        this.i = 0;
        this.n = this.words[0].length;
        this.deleting = true;
        this.out.textContent = this.words[0];
      }

      later(ms) {
        if (this.timer || reduce.matches) return;
        this.timer = setTimeout(() => this.step(), ms);
      }

      step() {
        this.timer = null;
        if (!this.visible || document.hidden || reduce.matches) return;
        const word = this.words[this.i];
        if (this.deleting) {
          this.n -= 1;
          this.out.textContent = word.slice(0, this.n);
          if (this.n > 0) return this.later(36);
          this.deleting = false;
          this.i = (this.i + 1) % this.words.length;
          return this.later(240);
        }
        const next = this.words[this.i];
        this.n += 1;
        this.out.textContent = next.slice(0, this.n);
        if (this.n < next.length) return this.later(72);
        this.deleting = true;
        this.later(1700);
      }
    }
    customElements.define('gl-typewriter', GlTypewriter);
  }

  if (!customElements.get('gl-set')) {
    class GlSet extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-gl-set-add]');
        this.label = this.querySelector('[data-gl-set-label]');
        this.msg = this.querySelector('[data-gl-set-msg]');
        if (this.button) this.button.addEventListener('click', () => this.add());
      }

      say(text, isError) {
        if (!this.msg) return;
        this.msg.textContent = text || '';
        this.msg.classList.toggle('is-error', Boolean(isError));
      }

      async add() {
        const ids = [...this.querySelectorAll('[data-gl-variant]')]
          .map((el) => Number(el.dataset.glVariant))
          .filter(Boolean);
        if (!ids.length || this.busy) return;
        this.busy = true;
        const idle = this.label.textContent;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.label.textContent = this.dataset.busy;
        this.say('');

        const cart = document.querySelector('cart-drawer');
        const canRender = cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
        const body = { items: ids.map((id) => ({ id, quantity: 1 })) };
        const withSections = (payload) => {
          if (!canRender) return payload;
          payload.sections = cart.getSectionsToRender().map((s) => s.id);
          payload.sections_url = window.location.pathname;
          return payload;
        };
        if (canRender && typeof cart.setActiveElement === 'function') cart.setActiveElement(this.button);
        const post = (url, payload) =>
          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });

        try {
          const res = await post((window.routes && window.routes.cart_add_url) || '/cart/add', withSections(body));
          const data = await res.json();
          if (!res.ok || data.status) {
            this.say(data.description || data.message || this.dataset.error, true);
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gliter-set', cartData: data });
          }
          if (canRender) {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
            this.say(this.dataset.done);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        } catch (e) {
          this.say(this.dataset.error, true);
        } finally {
          this.busy = false;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          this.label.textContent = idle;
        }
      }
    }
    customElements.define('gl-set', GlSet);
  }

  /* A looping hero video stays still for people who asked the system for less motion. */
  const stillVideos = () => {
    if (!reduce.matches) return;
    document.querySelectorAll('.gl-hero__media video').forEach((v) => {
      v.removeAttribute('autoplay');
      v.pause();
      v.controls = true;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stillVideos);
  else stillVideos();
})();
